module.exports = __webpack_public_path__ + "static/media/restaurant5.911b99ae.jpg";